const classroom = localStorage?.CURRENT_CENTER_ID || localStorage?.selectedGroupId;

export const messages = {
  fileAttachments: {
    chat: {
      maxMbFileSize: 300,
      accept: 'image/jpg,image/png,video/mp4,video/avi,video/mov,.pdf',
      getS3path: (chatId: any) =>
        `/${localStorage?.ORGANIZATION_ID}/${classroom}/messages/${chatId}/`,
    },
    newAnnouncement: {
      maxMbFileSize: 300,
    },
  },
};
